/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import axios from 'axios';

// initial state
const state = {
  locations: null,
  loaders: {
    locations: false,
  },
  initializers: {
    locations: false,
  },
};

// getters
const getters = {
  locations: (state) => state.locations,
  loaders: (state) => state.loaders,
  initializers: (state) => state.initializers,
};

// actions
const actions = {
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },

  getLocations({ commit }) {
    commit('TOGGLE_LOADING', { key: 'locations', value: true });
    return axios.get(`${CONFIG.get('BASE_URL')}/api/locations/getLocations/`)
      .then(({ data }) => {
        // Don't do this if not using large top banner
        commit('SET_PROPERTY', { key: 'locations', value: data });
      })
      .catch(() => {})
      .finally(() => {
        commit('TOGGLE_LOADING', { key: 'locations', value: false });
      });
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
